import { Injectable } from '@angular/core';
import { TableColumn, SortHelper, SortService } from '@app/shared';

@Injectable({
  providedIn: 'root'
})
export class ProjectSortService {
  constructor(private sortService: SortService) {}

  handleSort<T>(column: TableColumn, data: T[], columnsData: TableColumn[]): { sortedData: T[], newDirection: 'asc' | 'desc' | null } {
    if (!column.pathData) {
      return { sortedData: data, newDirection: null };
    }
    const currentDirection = column.sortDirection || null;
    const { sortedData, newDirection } = this.sortService.applySort(data, column, currentDirection);
    SortHelper.resetOtherColumns(columnsData, column);
    column.sortDirection = newDirection;
    return { sortedData, newDirection };
  }

  setupSortWhenOptionListReady<T>(columns: TableColumn[], columnName: string, optionList: any[], onSort: (column: TableColumn) => void): void {
    SortHelper.setupSortWhenOptionListReady(columns, columnName, optionList, onSort);
  }

  configureSortFunctions(columns: TableColumn[], onSort: (column: TableColumn) => void): void {
    SortHelper.configureSortFunctions(columns, onSort);
  }
}
